export function getView(activityType) {
  switch (activityType) {
    case 'comment':
      return 'Comment'
    case 'creation':
      return 'Creation'
    case 'log':
      return 'Log'
    default:
      return 'No'
  }
}
